<template>
  <div class="file-page-title">
    <div class="title">
      <i class="title-icon iconfont icon-wenjian" />
      <span class="file-nav mg-rt-sm" @click.stop="toFilePage">文件</span>
      <span class="mg-rt-sm">/</span>
      <span>轻量化合模</span>
    </div>
    <div>
      <span
          class="tab-span"
          :class="{'active-tab': $route.name === 'FederationPlanList'}"
          @click.stop="toPage('FederationPlanList')"
      >合模方案</span>
      <span
          class="tab-span"
          :class="{'active-tab': $route.name === 'IntegratedModelList'}"
          @click.stop="toPage('IntegratedModelList')"
      >交付模型</span>
    </div>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'FilePageTitle',
  data() {
    return {
      spaceId: this.$route.params.spaceId,
    }
  },
  mounted() {
    // 文件更新，弹框评分
    this.checkFeedbackExists()
  },
  methods: {
    ...mapActions({
      checkFeedbackExists: 'feedback/checkFeedbackExists',
    }),
    toFilePage() {
      this.$router.replace({ name: 'File', params: { spaceId: this.spaceId }})
    },
    toPage(routeName) {
      this.$router.push({ name: routeName, params: { spaceId: this.spaceId }})
    },
  },
}
</script>

<style lang="less" scoped>
.file-page-title{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #D2D9E3;
  padding: 12px 0;
}
.title{
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
  padding: 0 16px;
  .title-icon{
    margin-right: 8px;
    font-size: 24px;
  }
  .file-nav{
    color: rgba(73, 95, 112, 0.4);
    &:hover{
      cursor: pointer;
      color: @theme-color;
    }
  }
}
.tab-span{
  display: inline-block;
  padding: 4px 10px;
  background: @bg-grey-normal;
  border-radius: 20px;
  cursor: pointer;
  &:hover{
    background: @theme-color-hover;
  }
  &.active-tab{
    background: @theme-color-hover;
    color: @theme-color;
  }
  &+.tab-span{
    margin-left: 10px;
  }
}
</style>
